/*
  within this app, a set of coordinates refers to an object of the form:
  {
    left: [# of pixels to the right of the left edge of app_element],
    top: [# of pixels below the top edge of app_element],
  }

  returns:
  {
    upper_left: [coordinates of u-l corner of element],
    lower_right: [coordinates of l-r cornder of element],
    center: [coordinates of center of element]
  }
*/
export default function getAppCoordinates(element) {
  /*
    Note - this implementation assumes app_element element is fixed to upper left of viewport
    We'll have to update if that changes (by taking app_element.getBoundingClientRect() into consideration).
  */
  var rect = element.getBoundingClientRect();
  return {
    upper_left: {
      left: rect.left,
      top: rect.top,
    },
    lower_right: {
      left: rect.left + rect.width,
      top: rect.top + rect.height,
    },
    center: {
      left: rect.left + rect.width / 2,
      top: rect.top + rect.height / 2,
    },
  };
}


// WEBPACK FOOTER //
// ./src/AppCoordinateManager.js